export default __webpack_public_path__ + "static/media/token_bg.16934f49.png";